{
  "shellSkipMenuMainContent": "Zum Hauptinhalt springen"
}
